import { object, string } from "yup";

const loginSchema = object().shape({
    email: string().required("Le champ est requis").email("L'adresse email n'est pas valide"),
    password: string().required("Le champ est requis"),
});

export default loginSchema;
